

import Splide from '@splidejs/splide';




/**
 * Initialize the Splide slider on DOMContentLoaded event.
 */
export default function setupSlider () {
    window.addEventListener('DOMContentLoaded', () => {
        if (!document.querySelector('.splide')) return;

        window.splide = new Splide('.splide', {
            type: 'loop',
            perPage: 3,
            gap: '1rem',
            pagination: true,
            focus: 0,
            breakpoints: {
                991: {
                    perPage: 2,
                },
                767: {
                    perPage: 1,
                },
            },
        });

        window.splide.mount();
        window.initialSlides = [...splide.Components.Slides.get()];
    });
}
